export const WHAT_WE_MAKE = [
  {
    id: "door-hangers",
    title: "Door Hangers",
    description: "Basswood door hangers with layered lettering, painted details, seasonal accents, and personalized wording for everyday or holiday display.",
  },
  {
    id: "family-name-signs",
    title: "Family Name Signs",
    description: "Layered basswood family signs with names, dates, monograms, and custom styling for entryways, porches, and living spaces.",
  },
  {
    id: "seasonal-decor",
    title: "Seasonal Decor",
    description: "Painted and stained basswood pieces for holidays, front doors, mantels, shelves, and festive home displays year-round.",
  },
  {
    id: "nursery-signs",
    title: "Nursery Signs",
    description: "Lightweight layered wood decor for baby names, bows, themed room signs, and custom nursery pieces made from laser-cut basswood.",
  },
  {
    id: "business-logo-signs",
    title: "Business Logo Signs",
    description: "Laser-cut basswood designs for boutiques, vendor booths, salons, and small business branding with custom paint and stain finishes.",
  },
  {
    id: "memorial-pieces",
    title: "Memorial Pieces",
    description: "Thoughtful layered basswood memorial signs and keepsakes created with names, dates, phrases, and artwork suited for remembrance pieces.",
  },
  {
    id: "interchangeable-inserts",
    title: "Interchangeable Inserts",
    description: "Seasonal insert sets and interchangeable basswood sign accents that let one display change with holidays, sports seasons, or family events.",
  },
  {
    id: "custom-gifts",
    title: "Custom Gifts",
    description: "Personalized basswood signs and keepsake pieces for weddings, anniversaries, new babies, housewarmings, and meaningful gift-giving.",
  },
  {
    id: "layered-wall-decor",
    title: "Layered Wall Decor",
    description: "Basswood wall signs and raised 3D decor designed, cut, painted, and assembled by hand for homes, offices, and event spaces.",
  },
];

export const GALLERY_CATEGORIES = [
  "All",
  "Patriotic & Military",
  "Halloween & Spooky",
  "Fall & Harvest",
  "Summer & Beach",
  "Sports",
  "Pets & Animals",
  "Everyday Welcome & Home",
  "Camping & Outdoors",
  "Flowers, Bees & Nature",
  "Pop Culture & Novelty",
];

const productAsset = (fileName) =>
  `/imported-images/Beyond%20Board%20Woodworking%20Website%20Pictures/${encodeURIComponent(fileName)}`;

const IMPORTED_GALLERY_FILES = [
  "IMG_20260920_210519 (1).jpg",
  "IMG_20260920_210519 (10).jpg",
  "IMG_20260920_210519 (11).jpg",
  "IMG_20260920_210519 (12).jpg",
  "IMG_20260920_210519 (13).jpg",
  "IMG_20260920_210519 (14).jpg",
  "IMG_20260920_210519 (15).jpg",
  "IMG_20260920_210519 (16).jpg",
  "IMG_20260920_210519 (17).jpg",
  "IMG_20260920_210519 (18).jpg",
  "IMG_20260920_210519 (19).jpg",
  "IMG_20260920_210519 (2).jpg",
  "IMG_20260920_210519 (20).jpg",
  "IMG_20260920_210519 (21).jpg",
  "IMG_20260920_210519 (3).jpg",
  "IMG_20260920_210519 (4).jpg",
  "IMG_20260920_210519 (5).jpg",
  "IMG_20260920_210519 (6).jpg",
  "IMG_20260920_210519 (7).jpg",
  "IMG_20260920_210519 (8).jpg",
  "IMG_20260920_210519 (9).jpg",
  "IMG_20260920_210519.jpg",
  "IMG_20260920_210520 (1) (1).jpg",
  "IMG_20260920_210520 (1) (2).jpg",
  "IMG_20260920_210520 (1) (3).jpg",
  "IMG_20260920_210520 (1) (4).jpg",
  "IMG_20260920_210520 (1) (5).jpg",
  "IMG_20260920_210520 (1).jpg",
  "IMG_20260920_210520 (10).jpg",
  "IMG_20260920_210520 (11).jpg",
  "IMG_20260920_210520 (12).jpg",
  "IMG_20260920_210520 (13).jpg",
  "IMG_20260920_210520 (14).jpg",
  "IMG_20260920_210520 (15).jpg",
  "IMG_20260920_210520 (16).jpg",
  "IMG_20260920_210520 (17).jpg",
  "IMG_20260920_210520 (18).jpg",
  "IMG_20260920_210520 (19).jpg",
  "IMG_20260920_210520 (2).jpg",
  "IMG_20260920_210520 (20).jpg",
  "IMG_20260920_210520 (21).jpg",
  "IMG_20260920_210520 (22).jpg",
  "IMG_20260920_210520 (23).jpg",
  "IMG_20260920_210520 (24).jpg",
  "IMG_20260920_210520 (25).jpg",
  "IMG_20260920_210520 (26).jpg",
  "IMG_20260920_210520 (27).jpg",
  "IMG_20260920_210520 (28).jpg",
  "IMG_20260920_210520 (29).jpg",
  "IMG_20260920_210520 (3).jpg",
  "IMG_20260920_210520 (30).jpg",
  "IMG_20260920_210520 (31).jpg",
  "IMG_20260920_210520 (4).jpg",
  "IMG_20260920_210520 (5).jpg",
  "IMG_20260920_210520 (6).jpg",
  "IMG_20260920_210520 (7).jpg",
  "IMG_20260920_210520 (8).jpg",
  "IMG_20260920_210520 (9).jpg",
  "IMG_20260920_210520.jpg",
  "IMG_20260920_210525 (1).jpg",
  "IMG_20260920_210525 (10).jpg",
  "IMG_20260920_210525 (11).jpg",
  "IMG_20260920_210525 (12).jpg",
  "IMG_20260920_210525 (13).jpg",
  "IMG_20260920_210525 (14).jpg",
  "IMG_20260920_210525 (15).jpg",
  "IMG_20260920_210525 (16).jpg",
  "IMG_20260920_210525 (17).jpg",
  "IMG_20260920_210525 (18).jpg",
  "IMG_20260920_210525 (2).jpg",
  "IMG_20260920_210525 (3).jpg",
  "IMG_20260920_210525 (4).jpg",
  "IMG_20260920_210525 (5).jpg",
  "IMG_20260920_210525 (6).jpg",
  "IMG_20260920_210525 (7).jpg",
  "IMG_20260920_210525 (8).jpg",
  "IMG_20260920_210525 (9).jpg",
  "IMG_20260920_210525.jpg",
];

const categorySequence = GALLERY_CATEGORIES.filter((category) => category !== "All");

const GALLERY_METADATA_BY_FILE = {
  "IMG_20260920_210519 (1).jpg": { title: "Proud Veteran Home Sign", categories: ["Patriotic & Military"] },
  "IMG_20260920_210519 (10).jpg": { title: "Sunflower Hello Welcome Sign", categories: ["Flowers, Bees & Nature", "Everyday Welcome & Home"] },
  "IMG_20260920_210519 (11).jpg": { title: "Hello Sweet Summertime Strawberry Sign", categories: ["Summer & Beach", "Flowers, Bees & Nature"] },
  "IMG_20260920_210519 (12).jpg": { title: "Hello Summer Flip-Flop Sign", categories: ["Summer & Beach"] },
  "IMG_20260920_210519 (13).jpg": { title: "Hello Summer Popsicle Sign", categories: ["Summer & Beach"] },
  "IMG_20260920_210519 (14).jpg": { title: "Hello Summer Strawberry Sign", categories: ["Summer & Beach", "Flowers, Bees & Nature"] },
  "IMG_20260920_210519 (15).jpg": { title: "Wipe Your Flip Flops Sign", categories: ["Summer & Beach", "Everyday Welcome & Home"] },
  "IMG_20260920_210519 (16).jpg": { title: "Beach House Nautical Sign", categories: ["Summer & Beach", "Everyday Welcome & Home"] },
  "IMG_20260920_210519 (17).jpg": { title: "Football & Pumpkin 'Tis the Season Sign", categories: ["Fall & Harvest", "Sports"] },
  "IMG_20260920_210519 (18).jpg": { title: "Hello Fall Squirrel Sign", categories: ["Fall & Harvest", "Pets & Animals"] },
  "IMG_20260920_210519 (19).jpg": { title: "Grandkids Welcome Sign", categories: ["Everyday Welcome & Home"] },
  "IMG_20260920_210519 (2).jpg": { title: "Patriotic Floral Welcome Sign", categories: ["Patriotic & Military", "Everyday Welcome & Home", "Flowers, Bees & Nature"] },
  "IMG_20260920_210519 (20).jpg": { title: "Cow Print Welcome Sign", categories: ["Everyday Welcome & Home", "Pets & Animals"] },
  "IMG_20260920_210519 (21).jpg": { title: "Hi Silly Goose Sign", categories: ["Pets & Animals", "Everyday Welcome & Home"] },
  "IMG_20260920_210519 (3).jpg": { title: "Patriotic Stars Welcome Sign", categories: ["Patriotic & Military", "Everyday Welcome & Home"] },
  "IMG_20260920_210519 (4).jpg": { title: "Patriotic Eagle Welcome Sign", categories: ["Patriotic & Military", "Everyday Welcome & Home"] },
  "IMG_20260920_210519 (5).jpg": { title: "Let's Get Toasted Campfire Sign", categories: ["Camping & Outdoors"] },
  "IMG_20260920_210519 (6).jpg": { title: "Camp Wannabrewski Sign", categories: ["Camping & Outdoors", "Pop Culture & Novelty"] },
  "IMG_20260920_210519 (7).jpg": { title: "Probably at the Fire Pit Sign", categories: ["Camping & Outdoors"] },
  "IMG_20260920_210519 (8).jpg": { title: "Hello Honey Bee Gnome Sign", categories: ["Flowers, Bees & Nature", "Everyday Welcome & Home"] },
  "IMG_20260920_210519 (9).jpg": { title: "Bee Nice or Buzz Off Sign", categories: ["Flowers, Bees & Nature", "Pop Culture & Novelty"] },
  "IMG_20260920_210519.jpg": { title: "God Bless America Sign", categories: ["Patriotic & Military"] },
  "IMG_20260920_210520 (1) (1).jpg": { title: "It's Tricky Ghost Sign", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210520 (1) (2).jpg": { title: "Hey Boo Ghost Sign", categories: ["Halloween & Spooky"] },
  "IMG_20260920_210520 (1) (3).jpg": { title: "Halloween Skull & Spiderweb Wreath", categories: ["Halloween & Spooky"] },
  "IMG_20260920_210520 (1) (4).jpg": { title: "Platform 9 3/4 Sign", categories: ["Pop Culture & Novelty"] },
  "IMG_20260920_210520 (1) (5).jpg": { title: "Hello Pumpkin Floral Sign", categories: ["Fall & Harvest", "Flowers, Bees & Nature"] },
  "IMG_20260920_210520 (1).jpg": { title: "Welcome Hope You Like Dogs Sign", categories: ["Pets & Animals", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (10).jpg": { title: "Crazy Dog Lady Lives Here Sign", categories: ["Pets & Animals", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (11).jpg": { title: "Hello Summer Popsicle Sign", categories: ["Summer & Beach"] },
  "IMG_20260920_210520 (12).jpg": { title: "Buzz Off Bee & Daisy Sign", categories: ["Flowers, Bees & Nature"] },
  "IMG_20260920_210520 (13).jpg": { title: "Red White & Blue Welcome Sign", categories: ["Patriotic & Military", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (14).jpg": { title: "Here for the Boos Jar Set", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210520 (15).jpg": { title: "Hummingbird Flower Hello Jar", categories: ["Flowers, Bees & Nature", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (16).jpg": { title: "Berry Sweet Strawberry Jar", categories: ["Summer & Beach", "Flowers, Bees & Nature"] },
  "IMG_20260920_210520 (17).jpg": { title: "Bee & Flower Hello Jar", categories: ["Flowers, Bees & Nature", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (18).jpg": { title: "Sweet Summer Watermelon Jar", categories: ["Summer & Beach"] },
  "IMG_20260920_210520 (19).jpg": { title: "Summer Magic Jar Sign", categories: ["Summer & Beach", "Flowers, Bees & Nature"] },
  "IMG_20260920_210520 (2).jpg": { title: "Cats Welcome People Tolerated Sign", categories: ["Pets & Animals", "Everyday Welcome & Home", "Pop Culture & Novelty"] },
  "IMG_20260920_210520 (20).jpg": { title: "Hello Summer Lemon Jar", categories: ["Summer & Beach", "Flowers, Bees & Nature"] },
  "IMG_20260920_210520 (21).jpg": { title: "God Bless America Patriotic Jar", categories: ["Patriotic & Military"] },
  "IMG_20260920_210520 (22).jpg": { title: "Mummy Jar Halloween Sign", categories: ["Halloween & Spooky"] },
  "IMG_20260920_210520 (23).jpg": { title: "Scarecrow Harvest Jar", categories: ["Fall & Harvest"] },
  "IMG_20260920_210520 (24).jpg": { title: "Hello Fall Jar Sign", categories: ["Fall & Harvest"] },
  "IMG_20260920_210520 (25).jpg": { title: "Out of Candy Ghost Jar", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210520 (26).jpg": { title: "Floral Highland Cow Sign", categories: ["Pets & Animals", "Flowers, Bees & Nature"] },
  "IMG_20260920_210520 (27).jpg": { title: "KPOP Demon Hunters Sign", categories: ["Pop Culture & Novelty"] },
  "IMG_20260920_210520 (28).jpg": { title: "Welcome Dog Bones & Paw Prints Sign", categories: ["Pets & Animals", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (29).jpg": { title: "The Witch Is In Sign", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210520 (3).jpg": { title: "Home Sweet Home Paw Print Sign", categories: ["Pets & Animals", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (30).jpg": { title: "Moonlit Witch Halloween Sign", categories: ["Halloween & Spooky"] },
  "IMG_20260920_210520 (31).jpg": { title: "Thanksgiving Turkey Hi Sign", categories: ["Fall & Harvest", "Pets & Animals"] },
  "IMG_20260920_210520 (4).jpg": { title: "Home Is Where the Dog Is Sign", categories: ["Pets & Animals", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (5).jpg": { title: "We're Probably at the Rink Hockey Sign", categories: ["Sports"] },
  "IMG_20260920_210520 (6).jpg": { title: "Pittsburgh Football Sign", categories: ["Sports"] },
  "IMG_20260920_210520 (7).jpg": { title: "Baseball Home Sweet Home Sign", categories: ["Sports", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (8).jpg": { title: "Check the Ballfield Baseball Sign", categories: ["Sports", "Everyday Welcome & Home"] },
  "IMG_20260920_210520 (9).jpg": { title: "Welcome Hope You Brought Tequila Sign", categories: ["Summer & Beach", "Pop Culture & Novelty", "Everyday Welcome & Home"] },
  "IMG_20260920_210520.jpg": { title: "Sunflower Welcome Door Hanger", categories: ["Flowers, Bees & Nature", "Everyday Welcome & Home"] },
  "IMG_20260920_210525 (1).jpg": { title: "Grim Reaper Halloween Light", categories: ["Halloween & Spooky"] },
  "IMG_20260920_210525 (10).jpg": { title: "Haunted Mouse House Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (11).jpg": { title: "Haunted Tree Swing Display", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (12).jpg": { title: "Masked Horror Tree Swing Display", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (13).jpg": { title: "Ghost Mask Tree Swing Display", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (14).jpg": { title: "Striped Sweater Horror Tree Swing Display", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (15).jpg": { title: "United We Stand Eagle Sign", categories: ["Patriotic & Military"] },
  "IMG_20260920_210525 (16).jpg": { title: "American Flag Eagle Welcome Sign", categories: ["Patriotic & Military", "Everyday Welcome & Home"] },
  "IMG_20260920_210525 (17).jpg": { title: "Red White & Boom Fireworks Sign", categories: ["Patriotic & Military", "Summer & Beach"] },
  "IMG_20260920_210525 (18).jpg": { title: "America Land That I Love Sign", categories: ["Patriotic & Military"] },
  "IMG_20260920_210525 (2).jpg": { title: "Ghost Mask Halloween Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (3).jpg": { title: "Friday Horror Mask Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (4).jpg": { title: "Creepy Clown Halloween Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (5).jpg": { title: "Haunted Castle Mouse Silhouette Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (6).jpg": { title: "Moonlit Spiral Hill Couple Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (7).jpg": { title: "Moonlit Spiral Hill Figure Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525 (8).jpg": { title: "Fantasy Castle Mouse Silhouette Light", categories: ["Pop Culture & Novelty"] },
  "IMG_20260920_210525 (9).jpg": { title: "Flying Witch Moonlight Scene", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
  "IMG_20260920_210525.jpg": { title: "Masked Graveyard Horror Light", categories: ["Halloween & Spooky", "Pop Culture & Novelty"] },
};

const PORTFOLIO_ENTRIES = IMPORTED_GALLERY_FILES.map((fileName, index) => {
  const metadata = GALLERY_METADATA_BY_FILE[fileName] || {};
  const category = metadata.categories?.[0] || categorySequence[index % categorySequence.length];
  const categories = metadata.categories || [category];

  return {
    fileName,
    title: metadata.title || `${category} Piece ${index + 1}`,
    categories,
    description: "Custom Beyond Board Woodworking piece from the studio portfolio.",
  };
});

export const PRODUCT_CATALOG = PORTFOLIO_ENTRIES.map((entry, index) => ({
  id: `g${index + 1}`,
  ...entry,
  image: productAsset(entry.fileName),
  category: entry.categories[0],
}));

export const GALLERY_ITEMS = PRODUCT_CATALOG;
export const FEATURED = PRODUCT_CATALOG.slice(0, 12);

export const POPULAR_CATEGORIES = [
  { name: "Patriotic & Military", image: productAsset("IMG_20260920_210519.jpg") },
  { name: "Everyday Welcome & Home", image: productAsset("IMG_20260920_210520.jpg") },
  { name: "Fall & Harvest", image: productAsset("IMG_20260920_210525.jpg") },
  { name: "Flowers, Bees & Nature", image: productAsset("IMG_20260920_210520 (21).jpg") },
];

export const STATUS_OPTIONS = [
  "New Request",
  "Needs Follow-Up",
  "Quote Sent",
  "Approved",
  "In Design",
  "In Production",
  "Completed",
  "Archived",
];
